import React from 'react'

const Modal = ( {onClose, date, title, organization, description} ) => {
  return (
    <div className='absolute top-0 bottom-0 left-0 right-0 bg-opacity-25 backdrop-blur-sm bg-black' onClick={onClose}>
      <div className='flex justify-center align-items' onClick={onClose}>
          <div className='h-[calc((100dvh-80px))] w-[75dvw] pb-10 flex flex-col justify-center lg:h-[calc((100dvh-80px)/2)]'>
              <button className='flex justify-end text-white text-xl' onClick={onClose}>X</button>
              <div className='bg-white p-2 rounded text-black'>
                  <h1 className='flex justify-center text-sm font-bold whitespace-pre'> {date} </h1>
                  <h1 className='flex justify-start text-left text-[#261078] text-xs whitespace-pre'> {title} </h1>
                  <h1 className='flex justify-start text-left text-xs whitespace-pre'> {organization} </h1>
                  <p className='flex flex-wrap py-2 text-xs whitespace-pre text-black'> {description} </p>
              </div>
          </div>
      </div>
    </div>
  )
}

export default Modal